import React from 'react';
import { InputProps, Input as InputTera } from 'tera-dls';
import { Controller } from 'react-hook-form';
import { useTeraForm } from '_common/dof/FormTera/TeraFormContext';
import { useTeraFormItem } from '_common/dof/FormTera/TeraItemContext';
import { customTwMerge } from 'tailwind-merge.config';

const Input = React.memo(({ ...props }: InputProps) => {
  const { form } = useTeraForm();
  const { item, config, rules } = useTeraFormItem();
  const { control } = form;

  return (
    <Controller
      {...item}
      control={control}
      rules={rules}
      render={({ field }) => (
        <InputTera
          data-object_type={item?.object_type}
          data-object_id={item?.object_id}
          placeholder="Vui lòng nhập"
          {...field}
          {...props}
          {...config?.field}
          className={customTwMerge(
            'w-full',
            props?.className,
            config?.class_name,
          )}
        />
      )}
    />
  );
});

export default Input;
